var config = {
	rootMargin: '500px 500px 500px 500px',
	  threshold: 0.01
};

function preloadImage(image){
	var $image = jQuery(image);
	var backgroundImage = false;
	var $backgroundElement;

	if(typeof $image.attr('data-responsive-background-image') !== "undefined" && $image.attr('data-responsive-background-image') !== false)
	{
		$backgroundElement = $image;

		$image = $image.children('img.desktop, img.mobile');
		backgroundImage = true;
	}
	$image.each(function(){
		jQuery(this).attr('src', jQuery(this).attr('data-src'));
		jQuery(this).attr('srcset', jQuery(this).attr('data-srcset'));

		if(window.navigator.userAgent.indexOf("Edge") > -1){
			jQuery(this).attr('src', jQuery(this).attr('src') + '?' + Math.random());
		}
	});
	

	if(backgroundImage)
	{
		new ResponsiveBackgroundImage($backgroundElement[0]);
	}
}

var imageArray = [];
var imageLoading = false;
var imageLoadingAnimationFrameReference;

function loadImageData(){
	if(imageLoading)
	{
		return;
	}

	if(imageArray.length == 0)
	{
		return;
	}

	var element = imageArray.shift();

	if(element) {
		var imageLoader = new Image();
		imageLoader.src = element.getAttribute('data-src');
		imageLoader.setAttribute('srcset', element.getAttribute('data-srcset'));
		imageLoader.setAttribute('sizes', element.getAttribute('sizes'));
		imageLoading = true;
		imageLoader.addEventListener('load', function () {
			if(imageLoadingAnimationFrameReference)
			{
				cancelAnimationFrame(imageLoadingAnimationFrameReference);
			}
			imageLoading = false;
			imageLoadingAnimationFrameReference = requestAnimationFrame(loadImageData);
		});

		if (imageLoader.complete) {
			imageLoading = false;
			if(imageLoadingAnimationFrameReference)
			{
				cancelAnimationFrame(imageLoadingAnimationFrameReference);
			}

			imageLoadingAnimationFrameReference = requestAnimationFrame(loadImageData);
		}
	}
	else
	{
		imageLoading = false;

		if(imageLoadingAnimationFrameReference)
		{
			cancelAnimationFrame(imageLoadingAnimationFrameReference);
		}

		imageLoadingAnimationFrameReference = requestAnimationFrame(loadImageData);
	}
}

function onIntersection(entries) {
	entries.forEach(function(entry){
		if(entry.intersectionRatio > 0){
			observer.unobserve(entry.target);
			preloadImage(entry.target);
		}
	});
}

var observer = new IntersectionObserver(onIntersection, config);

( function() {

		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		window.ResponsiveBackgroundImage = function () {
			function ResponsiveBackgroundImage(element) {
				var _this = this;

				_classCallCheck(this, ResponsiveBackgroundImage);

				this.element = element;

				var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

				if(width < 480){
					this.img = element.querySelector('img.mobile');
				} else {
					this.img = element.querySelector('img.desktop');
				}
				
				this.src = '';


				if(this.img) {

					this.img.addEventListener('load', function () {
						_this.update();
					});

					if (this.img.complete) {
						this.update();
					}
				}
			}

			_createClass(ResponsiveBackgroundImage, [{
				key: 'update',
				value: function update() {
					var src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;

					var parentNode = this.img.parentNode;

					// Create a hidden image clone
					var temp = this.img.cloneNode(false);
					temp.setAttribute('src', this.img.src);
					temp.style.position = 'fixed';
					temp.style.visibility = 'hidden';

					parentNode.appendChild(temp);

					// Delay is necessary to prevent image from flickering
					setTimeout( function() {
					  // Update actual image src
						 if (this.src !== src) {
							this.src = src;
							this.element.style.backgroundImage = 'url("' + this.src + '")';
						 }
					  
					  // Remove clone afterwards
					  parentNode.removeChild(temp);
					}.bind(this), 30);

					
				}
			}]);

			return ResponsiveBackgroundImage;
		}();

		var $images = jQuery('img[data-srcset]');
		
		$images.each(function(){
			observer.observe(jQuery(this)[0]);
		});

		var $backgroundImages = jQuery('[data-responsive-background-image]');
		$backgroundImages.each(function(){
			observer.observe(jQuery(this)[0]);
		});

		var $marqueeImages = jQuery('.marquee--component img[data-srcset]');
		$marqueeImages.each(function(){
			preloadImage(jQuery(this)[0]);
		});

		function debouncer(func, timeout) {
		   var timeoutID, timeout = timeout || 15;
		   return function () {
		      var scope = this, args = arguments;
		      clearTimeout(timeoutID);
		      timeoutID = setTimeout(function () {
		          func.apply(scope, Array.prototype.slice.call(args));
		      }, timeout);
		   }
		}

		window.addEventListener('resize', debouncer(function (event) {
			var $images = jQuery('img[data-srcset]');
		
			$images.each(function(){
				observer.observe(jQuery(this)[0]);
				imageArray.push(jQuery(this)[0]);
			});

			var $backgroundImages = jQuery('[data-responsive-background-image]');
			$backgroundImages.each(function(){
				observer.observe(jQuery(this)[0]);
			});
			loadImageData();
		}));

	})();